module.exports = __webpack_public_path__ + "static/media/chevron-up.9952d948.svg";